/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, EffectCoverflow } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import useElementOnScreen from "../../../../hooks/useElementOnScreen";
import CustomNextImage from "../Common/CustomNextImage";
import ScreenReaderOnly from "../Common/ScreenReaderOnly";

export default function ScrollingCards({ series_list, windowSize }) {
  const [currentPage, setCurrentPage] = useState(2);
  const changeActive = (current) => {
    setCurrentPage(current?.realIndex);
  };
  const [containerRef, isVisible] = useElementOnScreen({
    root: null,
    rootMargin: "0px",
    thresold: 1.0,
  });

  // const { userData } = useStore();
  // const { routeToSeries } = useRouting();
  // const isUserLoggedIn = userData?.phone;
  // const isCurrentUserPremium = userData?.is_premium;
  // const router = useRouter();

  // const handleRedirectToSeries = (data) => {
  //   // if (isUserLoggedIn) {
  //   //   if (isCurrentUserPremium) {
  //   //     routeToSeries({ slug: data?.slug });
  //   //   } else {
  //   //     const url = `/premium/?source=series&source_section=future_ready&series_slug=${data?.slug}`;
  //   //     router.push(url);
  //   //   }
  //   // } else {
  //   //   routeToLogin();
  //   // }
  //   // routeToSeries({ slug: data?.slug });
  // };

  useEffect(() => {
    if (isVisible) {
      const swiper = document?.querySelector(".swiper").swiper;
      swiper.slideNext(300);
    }
  }, [isVisible]);

  return (
    <div className={styles.scrollingCards} ref={containerRef}>
      {/* <div className={styles.scrollingCards_title}>{title}</div> */}
      <div className="my_slider_scrollbar">
        {windowSize >= 768
          ? isVisible && (
              <Swiper
                onSlideChange={(data) => changeActive(data)}
                centeredSlides={true}
                loop={true}
                slidesPerView={"auto"}
                initialSlide={currentPage}
                navigation={true}
                className={styles.mySwiper}
                effect={"coverflow"}
                direction="horizontal"
                coverflowEffect={{
                  rotate: 0,
                  stretch: 20,
                  depth: 500,
                  modifier: 1,
                  slideShadows: true,
                }}
                pagination={true}
                modules={[EffectCoverflow, Navigation]}
                style={{
                  height: "100%",
                  width: "100%",
                  marginTop: 80,
                  marginBottom: 80,
                }}
              >
                {[...series_list, ...series_list, ...series_list]?.map(
                  (data, index) => {
                    return (
                      <SwiperSlide key={index} style={{ height: "100%" }}>
                        <a href={`/video/${data?.slug}`}>
                          <ScreenReaderOnly content={data?.content} />
                          <CustomNextImage
                            src={data?.image}
                            alt="seekho"
                            width={180}
                            height={260}
                            priority={true}
                            className={`${styles.img_card} img_card_custom cursor-pointer`}
                            onClick={() => handleRedirectToSeries(data)}
                          />
                        </a>
                      </SwiperSlide>
                    );
                  }
                )}
              </Swiper>
            )
          : isVisible && (
              <Swiper
                centeredSlides={true}
                loop={true}
                slidesPerView="auto"
                initialSlide={0}
                navigation={false}
                effect="coverflow"
                coverflowEffect={{
                  rotate: 0,
                  stretch: 10,
                  depth: 150,
                  modifier: 3,
                  slideShadows: true,
                }}
                pagination={false}
                modules={[EffectCoverflow, Pagination]}
                style={{
                  height: "100%",
                  width: "100%",
                  marginTop: windowSize >= 768 && 80,
                  marginBottom: windowSize >= 768 && 80,
                }}
              >
                {series_list?.map((data, index) => {
                  return (
                    <SwiperSlide key={index} style={{ height: "100%" }}>
                      {/* <a href={`/video/${data?.slug}`}> */}
                      <ScreenReaderOnly content={data?.description} />
                      <CustomNextImage
                        src={data?.image}
                        alt="seekho"
                        width={135}
                        height={190}
                        // priority={true}
                        className={`${styles.img_card} img_card_custom`}
                        // onClick={() => handleRedirectToSeries(data)}
                      />
                      {/* </a> */}
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            )}
      </div>
      {/* <div className={styles.downloadapp}>
                <a className={styles.start_learning} href="https://play.google.com/store/apps/details?id=com.seekho.android"  target="_blank">
                    <img alt="seekho" src="assets/socials/logos_google.webp" className={styles.img_google}/>
                    Download the app
                    <img alt="seekho" src="assets/longArrow.svg" className={styles.img_google}/>
                </a>
            </div> */}
    </div>
  );
}
